export const uri = {
  // general
  getAll: '/all',
  byTenant: '/by-tenant',
  getUserMe: '/users/me',
  userExistsForCurrentMandant: '/users/exists-for-current-mandant',
  getUserMeUpdate: '/users/me/update',
  getAllUsersByTenant: '/users/by-customer',
  userUpdateContactDataPsw: '/users/update/contactDataAndPassword',
  deleteFile: '/documents/delete',
  uiAdaptions: '/settings/adaptions',
  uiAdaptionsAdmin: '/settings/adaptions/admin',
  priceCalculation: '/price-calculation/entries',
  codeListValues: '/meta/codelistvalues',
  workflowRule: '/workflow-rules',
  codeListValuesByTenant: '/meta/codelistvalues/byTenant',
  uiAdaptionsByTenant: '/settings/adaptions/bycurrenttenant',
  companyLocationByCurrentTenant: '/companylocations/bycurrenttenant',
  saveCompanyLocation: '/companylocation',
  areaTypes: '/areatypes',
  updateBackofficeSettings: '/user/updatebackofficesettings',
  getAllRoles: '/roles/getall',
  saveRole: '/roles/save',
  updateUserRole: '/usersroles/update',
  updateUserAreaType: '/areatypes/update',
  getAllTenants: '/tenants',
  getAllPrivileges: '/privileges',
  getActiveDevelopmentAreas: '/developmentAreas/active',
  documents: '/documents',
  uploads: '/uploads',
  archive: '/archive',
  nextActions: '/actions',

  // companyLocation-AreaTypes
  companyLocationAreaType: '/companylocationareatype',
  getAllCompanyLocationAreaTypeByCompanyLocation: '/companylocationareatype',

  // businessPartner
  businessPartner: '/businesspartner',
  hapBusinessPartnerFilter: '/businesspartner/filter',
  businessPartnerByCurrentTenant: '/businesspartner/bycurrenttenant',

  // imports
  importTechnician: '/import/technician',
  importInstallerPasses: '/import/initialInstallerImport',

  // HAP

  // OrderRequest
  hapOrderRequests: '/orders',
  hapGetAllOrderRequest: '/orders/filter',
  hapGetOrderRequestDetail: '/order-request-detail/',
  hapOrderGetAllContactNameByTenant: '/orders/contactFilterValues',
  hapOrdersCompleteTechnically: '/orders/completeTechnically',
  hapOrdersCompleteTechnicallyV2: '/orders/completeTechnically/v2',
  hapOrdersComplete: '/orders/complete',
  hapOrdersCreateFelixProject: '/orders/createFelixProject',
  hapRequestApproval: '/orders/requestApproval',
  hapResetApproval: '/orders/resetApproval',
  hapApproveOrderRequestExternal: '/external/orders/approve',
  hapCancelOrderRequest: '/orders/cancel',

  // ConnectionChange
  hapConnectionChange: '/connection-change-requests',
  hapConnectionChangeList: '/connection-change-requests/filter/v2',

  // ConnectionChange - Actions
  hapConnectionChangeRequestOffer: '/connection-change-requests/request',
  hapConnectionChangeRequestFeedback: '/connection-change-requests/requestFeedback',
  hapConnectionChangeSendOffer: '/connection-change-requests/sendOfferConfirmationRequest',
  hapExternalConnectionChangeRequestOffer: '/external/connection-change-requests/request',
  hapExternalConnectionChangeRequest: '/external/connection-change-requests',
  hapExternalConnectionChangeRequestConfirmOffer: '/external/connection-change-requests/confirm-offer',
  hapConnectionChangeRequestChangeStatus: '/connection-change-requests/change-status',
  hapConnectionChangeRequestRemove: '/connection-change-requests/',

  // Installateur
  tmCreateAdminUser: '/tmuser/admin',
  tmUser: '/tmuser',
  tmUsersByCompany: '/tmuser/bycompany',
  tmAllUsers: '/tmuser/all',
  tmChangePwd: '/tmuser/changepwd',
  tmInstallerPassFilter: '/installerpass/filter',
  tmGetConfigListDocuments: '/documents/config/tmdocumentlist',
  tmSaveConfigDocument: '/documents/config/updatetmdocument',
  tmGetAllPassesByuser: '/installerpass/byuser',
  tmGetAllPassesByOwnBusinessPartner: '/installerpass/byownbusinesspartner',
  tmInstallerpass: '/installerpass',
  tmInstallerpassRequestValidation: '/installerpass/requestvalidation',
  tmInstallerpassRequestFeddback: '/installerpass/request-feedback',
  tmInstallerpassRequestRenovation: '/installerpass/requestrenovation',
  tmInstallerpassValidateRenovation: '/installerpass/approvedrenovation',
  tmInstallerpassValidate: '/installerpass/approve',
  tmRejectInstallerPass: '/installerpass/reject',

  tmCheckActivationToken: '/tmuser/user/checktoken',
  tmUserActivation: '/tmuser/user/activation',
  updateUserCompanyLocations: '/users/company-locations/update',
  tmPdfInstallerPass: '/print/installerPass',

  //Commissioning
  cmCommissioningRequest: '/commissioningrequest',

  cmCloseCommissioningRequest: '/commissioningrequest/close',
  cmCommissioningRequestPageableFiltered: '/commissioningrequest/filter',
  cmCommissioningRequestForCurrentUser: '/commissioningrequest/me',
  cmCommissioningRequestOwnBusinessPartner: '/commissioningrequest/findAllByTechnicianBusinessPartnerId',
  cmPdfCommissioning: '/print/commissioningrequest',
  cmCommissioningRequestRequestApproval: '/commissioningrequest/requestApproval',
  cmCommissioningRequestChangeSupplyAppointment: '/commissioningrequest/change-supply-appointment',
  cmCommissioningRegistrationCorrectBeforeApproval: '/commissioningrequest/correct',
  cmApproveCommissioningRequest: '/commissioningrequest/approve',
  cmChangeAppointmentCommissioningRequest: '/commissioningrequest/change-supply-appointment',
  cmCommissioningRequestRequestFeedback: '/commissioningrequest/requestFeedback',
  cmCommissioningRequestReportDefect: '/commissioningrequest/reportDefect',
  cmDraftCommissioningFromGridReg: '/commissioningrequest/draft',
  cmCRGasRequestConfirmationChimneySweep: '/commissioningrequest/requestChimneySweepConfirmation',
  cmCRGetAllRelatedToGR: '/commissioningrequest/relatedToGridRegistration',
  cmCrChangeStatus: '/commissioningrequest/change-status',
  cmInstallationComplete: '/commissioningrequest/installationComplete',
  cmCommissioningRequestSendOffer: '/commissioningrequest/sendOffer',
  cmCommissioningRequestCommissionOffer: '/commissioningrequest/commissionOffer',
  cmCommissioningRequestTechnicalReview: '/commissioningrequest/technicalReview',
  cmCommissioningRequestSendNAV: '/commissioningrequest/sendNAV',

  cmCommissioningRequestExternal: '/external/commissioningrequest',
  cmCRGasExternalChimneySweepConfirmed: '/external/commissioningrequest/chimneySweepConfirmRequest',
  cmCRGasExternalChimneySweepRejected: '/external/commissioningrequest/chimneySweepRejectRequest',

  tmValidatePass: '/installerpass/validate',

  //GridRegistration
  cmMeteringRequest: '/meteringconcept',
  cmGetAllMeteringRequest: '/meteringconcept/all',
  cmGridRegistration: '/gridregistration',
  cmGridRegistrationFiltered: '/gridregistration/filter',
  cmGridRegistrationRequestApproval: '/gridregistration/requestApproval',
  cmGridRegistrationCorrectBeforeApproval: '/gridregistration/correct',
  cmGridRegistrationLoggedOff: '/gridregistration/external',
  cmGridRegistrationFormLoggedOffRequestApproval: '/gridregistration/external/requestapproval',
  cmGridRegistrationApproved: '/gridregistration/approved',
  cmGridRegistrationSendToReview: '/gridregistration/sendToReview',
  cmGridRegistrationCompleteReview: '/gridregistration/completeReview',
  cmGridRegistrationRequestFeedback: '/gridregistration/requestFeedback',
  cmGridRegistrationDeclined: '/gridregistration/declined',
  cmGridRegistrationFeedInManagementPrices: '/gridregistration/feedinmanagementprice',
  cmGridRegistrationByConnectionObject: '/gridregistration/byconnectionobject',
  cmGRTransferToTechnicianRequest: '/gridregistration/transfer-to-technician/request',
  cmGRChangeStatus: '/gridregistration/change-status',
  cmGRCompleted: '/gridregistration/completed',
  cmGRCompletedPositioning: '/gridregistration/completed-positioning',
  cmGRTransferToTechnicianGet: '/gridregistration/transfer-to-technician',
  cmGRTransferToTechnicianAccepted: '/gridregistration/transfer-to-technician/accepted',
  cmGridRegistrationRequestExternal: '/external/gridregistration',
  cmGrAssignToTechnician: '/external/gridregistration/gr-assign-technician',
  cmGrAssignToTechnicianConfirmation: '/external/gridregistration/gr-assign-technician-confirmation',
  cmGRConfirmFeedinOrder: '/external/gridregistration/confirmFeedInManagementOrder',
  cmGRConfirmFeedinConfigurationr: '/external/gridregistration/confirmFeedInConfigured',
  cmGridRegistrationApproveExtension: '/external/gridregistration/refreshValidity',
  cmSendMaloMeloMail: '/gridregistration/sendMaloMeloMail',
  cmSendTrSrMail: '/gridregistration/sendTrSrMail',
  cmGridRegistrationDisableMastrValidation: '/gridregistration/disableMastrValidation',

  cmCRequestConfirmationCustomerPlaceService: '/gridregistration/requestPlaceInServiceConfirmation',
  cmCRequestConfirmationStoragePlaceService: '/gridregistration/requestPlaceInServiceStorageConfirmation',
  cmCRPlaceServiceConfirmed: '/external/gridregistration/placeInServiceConfirmed',

  gridCompatibilityTests: '/grid-compatibility-tests',

  // FeederContract
  cmFeederContract: '/feeder-contracts',
  cmFeederContractPageableFiltered: '/feeder-contracts/filter',
  cmFeederContractRequestFeedback: '/feeder-contracts/requestFeedback',
  cmFeederContractDraftByGridRegistration: '/feeder-contracts/draft',
  cmFCChangeStatus: '/feeder-contracts/change-status',
  cmFeederContractSendOfferToCustomer: '/feeder-contracts/send-offer',
  cmFeederContractReSendOfferToCustomer: '/feeder-contracts/re-send-offer',
  cmFeederContractApproved: '/feeder-contracts/approved',
  cmFeederContractTechnicallyReviewed: '/feeder-contracts/technically-reviewed',
  cmFeederContractExternal: '/external/feeder-contracts',
  cmFeederContractExternalPreview: '/print/external/feederContract/preview',
  cmFeederContractExternalAcceptedWithoutContract: '/external/feeder-contracts/confirm-without-contract',
  cmFeederContractExternalAcceptedContract: '/external/feeder-contracts/confirm',

  cmCompCat: '/compensation_category',
  cmCompCatBySourceAndBetweenMonth: '/compensation_category/bySourceBetweenMonth',
  cmCompCatByName: '/compensation_category/name',
  getAllLineItemsByLookup: '/erp-integration/line-items',

  getZerezUnitInfo: '/gridregistration/zerez-data/'
};
